<div class="holder">
  <div class="d-flex justify-content-end">
    <button (click)="dismiss()" class="btn-close" title="Close"></button>
  </div>
  <div class="title" (click)="navigate()">
    <div
      [ngStyle]="{ 'background-image': 'url(' + image + ')' }"
      class="image"></div>
    <div class="texts">
      <div class="mb-3">{{ pretitle }}</div>
      <h1>{{ title }}</h1>
    </div>
  </div>

  <div
    class="messages"
    #messagePane
    [ngClass]="{ empty: messages.length === 0 }">
    <ng-container *ngIf="messages.length === 0">
      <div>
        <img src="/assets/images/direct-msg-empty.svg" alt />
        <p *ngIf="canPost()">Start the conversation by sending a message!</p>
      </div>
    </ng-container>

    <ng-container *ngFor="let msg of messages; index as i">
      <div
        class="msg"
        *ngIf="msg"
        [ngClass]="{
          announcement: msg.announcement,
          'greenish-bg': msg.announcement,
        }">
        <div class="bubble">
          <div class="sender" *ngIf="showSender(i)">
            <profile-picture
              class="me-1"
              [user]="$any(msg.created_by)"></profile-picture>
            <name-tag [user]="msg.created_by"></name-tag>
            <ng-container *ngIf="msg.announcement">
              <i class="icon-announcement"></i>
            </ng-container>
          </div>
          <div class="lines">
            <div class="date" *ngIf="showDate(i)">
              {{ msg.created_at | date: 'd/M/yy, h:mma' }}
            </div>
            <div class="line" *ngFor="let line of lines(msg)">
              <span innerHTML="{{ line }}"></span>
              <br *ngIf="!line || line.length === 0" />
            </div>
            <div
              class="del"
              *ngIf="mine(msg)"
              title="Delete message"
              (click)="delete(msg)">
              <span class="fa fa-trash"></span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="control" *ngIf="canPost()">
    <textarea
      ngbAutofocus
      placeholder="Write a message ..."
      [(ngModel)]="newMsg"></textarea>
    <div class="buttons">
      <button
        type="button"
        class="btn"
        style="float: left"
        [disabled]="!group || !newMsg || sending"
        (click)="announce()"
        *ngIf="canAnnounce()">
        Announce
        <i class="icon-announcement"></i>
      </button>
      <button type="button" class="btn" (click)="dismiss()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!group || !newMsg || sending"
        (click)="send()">
        Send
        <i class="icon-send-msg"></i>
      </button>
    </div>
  </div>
</div>
